/**
 * Application router.
 * Public MVP (Porto): home, lists, details, map. Admin: protected shell.
 */
import { Routes, Route } from 'react-router-dom';
import { PublicLayout } from '@/app/layouts/PublicLayout';
import { AdminLayout } from '@/app/layouts/AdminLayout';
import { ProtectedRoute, RoleRoute } from '@/app/router/guards';
import LoginPage from '@/pages/LoginPage';
import PublicHome from '@/pages/public/PublicHome';
import { PublicEvents, PublicPlaces, PublicActivities } from '@/pages/public/PublicLists';
import { PublicEventDetail, PublicPlaceDetail, PublicActivityDetail } from '@/pages/public/PublicDetails';
import PublicMap from '@/pages/public/PublicMap';
import AdminDashboardPage from '@/pages/AdminDashboardPage';
import MunicipalitiesPage from '@/pages/MunicipalitiesPage';
import PlacesAdmin from '@/pages/admin/PlacesAdmin';
import ActivitiesAdmin from '@/pages/admin/ActivitiesAdmin';
import MediaAdmin from '@/pages/admin/MediaAdmin';
import SettingsPage from '@/pages/admin/SettingsPage';
import UsersPage from '@/pages/admin/UsersPage';
import NotFoundPage from '@/pages/NotFoundPage';

export function AppRouter() {
        return (
                <Routes>
                        <Route element={<PublicLayout />}>
                                <Route path="/" element={<PublicHome />} />
                                <Route path="/eventi" element={<PublicEvents />} />
                                <Route path="/eventi/:slug" element={<PublicEventDetail />} />
                                <Route path="/luoghi" element={<PublicPlaces />} />
                                <Route path="/luoghi/:slug" element={<PublicPlaceDetail />} />
                                <Route path="/attivita" element={<PublicActivities />} />
                                <Route path="/attivita/:slug" element={<PublicActivityDetail />} />
                                <Route path="/mappa" element={<PublicMap />} />
                        </Route>

                        <Route path="/login" element={<LoginPage />} />

                        <Route element={<ProtectedRoute />}>
                                <Route element={<AdminLayout />}>
                                        <Route path="/admin" element={<AdminDashboardPage />} />
                                        <Route path="/admin/places" element={<PlacesAdmin />} />
                                        <Route path="/admin/activities" element={<ActivitiesAdmin />} />
                                        <Route path="/admin/media" element={<MediaAdmin />} />
                                        <Route element={<RoleRoute roles={['municipality_admin', 'super_admin']} />}>
                                                <Route path="/admin/config" element={<SettingsPage />} />
                                        </Route>
                                        <Route element={<RoleRoute roles={['municipality_admin']} />}>
                                                <Route path="/admin/users" element={<UsersPage />} />
                                        </Route>
                                        <Route element={<RoleRoute roles={['super_admin']} />}>
                                                <Route path="/admin/municipalities" element={<MunicipalitiesPage />} />
                                        </Route>
                                </Route>
                        </Route>

                        <Route path="*" element={<NotFoundPage />} />
                </Routes>
        );
}

export default AppRouter;
